import React, { createContext } from 'react'
import './ExploreFilterPage.scss'
import ExploreFilterWrapper from './ExploreFilterWrapper'
import PropTypes from 'prop-types'

export const ExplorePageContext = createContext()

class ExploreFilterPage extends React.Component {
  render() {
    const prefilteredCategories = this.props.prefilteredCategories
      ? this.props.prefilteredCategories.split(',')
      : []

    return (
      <ExplorePageContext.Provider
        value={{ userPresent: this.props.userPresent }}
      >
        <ExploreFilterWrapper
          baseUrl={this.props.baseUrl}
          categoryOptions={this.props.categories}
          prefilteredCategories={prefilteredCategories}
          defaultOrder={this.props.defaultOrder}
          intensity={this.props.intensity} // intensity is passed as a string when we get it from the url params
          difficulty={this.props.difficulty}
          instructorOptions={this.props.instructorOptions}
          equipmentTags={this.props.equipmentTags}
          focusAreaTags={this.props.focusAreaTags}
          defaultValue={this.props.defaultValue}
          filteredInstructors={this.props.filteredInstructors}
        />
      </ExplorePageContext.Provider>
    )
  }
}

ExploreFilterPage.propTypes = {
  baseUrl: PropTypes.string,
  categories: PropTypes.array,
  difficulty: PropTypes.string,
  intensity: PropTypes.string,
  prefilteredCategories: PropTypes.string,
  defaultOrder: PropTypes.string
}

export default ExploreFilterPage
